import React, { useState } from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import Loading from "../components/Loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const RewardsComponent = () => {
  const [selected, setSelected] = useState('rewards');

  return (
    <div className="rewards">
      <ul className="rewards-menu">
        <li className={selected === 'rewards' ? 'active' : ''} onClick={() => setSelected('rewards')} ><FontAwesomeIcon icon="gift" />My Rewards</li>
        <li className={selected === 'unlock' ? 'active' : ''} onClick={() => setSelected('unlock')}><FontAwesomeIcon icon="lock" />Unlockables</li>
      </ul>
      { selected === 'rewards' &&
        <div className="rewards-panel">
          <div className="rewards-thumb">🏆</div>
          <div className="rewards-content">
            <h5>Stay tuned!</h5>
            <div>Looks like you haven't received any rewards yet.</div>
            <small>Watch this space</small>
          </div>
        </div>
      }
      { selected === 'unlock' &&
        <div className="lock">
          <img src="/doge-pawstrong.png" width="300" />
          <span>🔒</span>
        </div>
      }
    </div>
  );
};

export default withAuthenticationRequired(RewardsComponent, {
  onRedirecting: () => <Loading />,
});
